export default "__VITE_ASSET__xIdbWlMv__"